// extracted by mini-css-extract-plugin
export default {"caption":"Caption_caption__HLuRF","caption--sm":"Caption_caption--sm__2E7Ci","caption--up-sm":"Caption_caption--up-sm__2TzHV"};